export default __webpack_public_path__ + "static/media/herz.b6fadd5c.jpg";